import React,{useContext} from 'react';
import { Contextone } from "./Context";
import { useHistory } from "react-router-dom";


const SwitchType = () => {
    const countercontext = useContext(Contextone);
    const history = useHistory();
    
    const handleSwitchNewsClick = ()=>{
        history.push("/");
        countercontext.setShowNewsContent(true)

    }
    const handleSwitchDesiClick = ()=>{
        history.push("/");
        countercontext.setShowNewsContent(false)
      }

   return (
        <>
        
             {!countercontext.showNewsContent ? 
            // <button className='switchText' onClick={handleSwitchNewsClick}> खबरें</button>:
            // <button className='switchText' onClick={handleSwitchDesiClick}> फिल्में</button>} 
             <ul><li className='Otherlist' onClick={handleSwitchNewsClick}> खबरें</li></ul>:
             <ul><li className='Otherlist' onClick={handleSwitchDesiClick}> फिल्में
             </li></ul>} 
        </>
    );
};

export default SwitchType;
